import React, { useContext, useRef } from "react";
import styled from "styled-components";
import {
    PortalFormDescription,
    PortalFormFieldGroup,
    PortalFormLabel,
    StandardModalActionButton,
    portalColors
} from "src/components";
import { NewCampaignContext } from "../NewCampaignContext";

const HeaderImageDropzone = styled.div`
    width: 100%;
    min-height: 8.5rem;
    display: grid;
    place-items: center;
    padding: 1rem;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background-color: ${portalColors.surfaceSoft};

    background-image: ${p =>
        p.$backgroundImage ? `url(${p.$backgroundImage})` : "none"};

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    box-sizing: border-box;
`;

export default function HeaderImage() {
    const { backgroundImage, setBackgroundImage, setEmailImageHeader } = useContext(NewCampaignContext);
    const fileInputRef = useRef(null);


    const handleUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setEmailImageHeader(file);
            const imageUrl = URL.createObjectURL(file);
            setBackgroundImage(imageUrl);
        }
        e.target.value = null;
    };

    const onImportCsvClick = () => {
        fileInputRef.current.click();
    };

    const removeHeaderImage = () => {
        setBackgroundImage(null);
    };
    return (
        <PortalFormFieldGroup>
            <PortalFormLabel>
                Header Image (Optional)
            </PortalFormLabel>
            <PortalFormDescription>
                Upload a custom header image. Use a wide image and keep important content centered.
            </PortalFormDescription>
            <HeaderImageDropzone $backgroundImage={backgroundImage}>
                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleUpload}
                />
                <StandardModalActionButton
                    type="button"
                    $variant={backgroundImage ? "secondary" : "primary"}
                    onClick={backgroundImage ? removeHeaderImage : onImportCsvClick}
                >
                    {backgroundImage ? "Remove Image" : "Browse Image"}
                </StandardModalActionButton>
            </HeaderImageDropzone>
        </PortalFormFieldGroup>
    );
}
